<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  render(h) {
    return h("div", this.renderElement(this.data, h));
  },
  methods: {
    renderElement(elements = [], h) {
      return elements.map((element) => {
        const methodName = `render${this.toTitle(element.type)}`;
        const render = this[methodName];

        if (typeof render === "function") {
          if (element.children && element.children[0].type === "text") {
            let attrs = {};
            attrs["aria-label"] = element.children[0].text;
            let type = element.type
            if(type === 'heading'){
              type =  `h${element.level}`
            }
            if(type === 'paragraph'){
              type =  'p'
            }
            return h(
              type,
              {
                attrs,
              },
              this.renderElement(element.children, h)
            );
          } else {
            return render.call(this, element, h);
          }
        } else {
          console.warn(`method ${methodName} is not implemented`);
          return null;
        }
      });
    },
    renderHeading(element, h) {
      return h(
        `h${element.level}`,
        {
          class: `is-size-${element.level + 1}`,
        },
        this.renderElement(element.children, h)
      );
    },
    renderParagraph(element, h) {
      console.log(h);
      return h("p", this.renderElement(element.children, h));
    },
    renderList(element, h) {
      return h("ul", this.renderElement(element.children, h));
    },
    renderListItem(element, h) {
      return h("li", this.renderElement(element.children, h));
    },
    renderText(element, h) {
      return element.text;
    },
    renderEmphasis(element, h) {
      return h("em", this.renderElement(element.children, h));
    },
    renderStrong(element, h) {
      return h("strong", this.renderElement(element.children, h));
    },
    toTitle(string) {
      return (
        string[0].toUpperCase() +
        string
          .slice(1)
          .split("_")
          .map((t, i) => (i === 0 ? t[0] : t[0].toUpperCase()) + t.slice(1))
          .join("")
      );

      return string[0].toUpperCase() + string.slice(1);
    },
  },
};
</script>
